
import Strongbox from "../../../assets/duotone/Strongbox.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StrongboxIcon({ className, dataTestid = "StrongboxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Strongbox data-testid={dataTestid} className={classes} {...rest} />
  );
}
